import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ciCustomManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  ciCustomManageForecastTreeData: [],
  ciCustomManageForecastFinalTreeData: [],
};

const CICustomManageScreenRedux = createSlice({
  name: "CICustomManageScreenRedux",
  initialState,
  reducers: {
    setCICustomManageForecastBottlerData: (state, action) => {
      state.ciCustomManageForecastBottlerData = action.payload;
    },
    setCICustomManageForecastTreeData: (state, action) => {
      state.ciCustomManageForecastTreeData = action.payload;
    },
    setCICustomManageForecastFinalTreeData: (state, action) => {
      state.ciCustomManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setCICustomManageForecastBottlerData,
  setCICustomManageForecastTreeData,
  setCICustomManageForecastFinalTreeData,
} = CICustomManageScreenRedux.actions;
export default CICustomManageScreenRedux.reducer;
